import {Question} from "./question";
import { QuestionSetLabel } from "./question-set-label";
import { QuestionType } from "app/shared/models/question-type";

export class SingleChoiceQuestion extends Question {
    private isSelected:boolean;

    constructor() {
        super();
        this.type = QuestionType.SingleChoice;
        this.isSelected = false;
    }
    
    public get answerDisplayText() :any{
        if (this.isSelected == true) {
            return "Checked";
        }
        else {
            return "Not Checked";
        }
    }

    public get answerForSave(): any {
        return {isSelected: this.isSelected};
    }

    public setSavedAnswer(data: any, labels: QuestionSetLabel[]) {
        if (data && data.isSelected === true) {
            this.isSelected = true;
        }
        else {
            this.isSelected = false;
        }
    }
    public hasAnswer(answer: any) {
        // it always has an answer if it's selected or not selected.
        return true;
    }
    public get isFilledOut() : boolean {
        return true;
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/models/single-choice-question.ts